





































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  GameConfigType,
  GameType,
  GameStateType,
  PlayersType,
  PlayerType,
  PurchasesType,
  UserType,
} from "@/types";
import Lobby from "@/components/game/Lobby.vue";
import Responses from "@/components/game/Responses.vue";
import Results from "@/components/game/Results.vue";
import Voting from "@/components/game/Voting.vue";

@Component({ components: { Lobby, Responses, Results, Voting } })
export default class Play extends Vue {
  @Prop({ required: true }) config!: GameConfigType;
  @Prop({ required: true }) game!: GameType;
  @Prop({ required: false }) purchases?: PurchasesType;
  @Prop({ required: true }) user!: UserType;

  get isOwner() {
    return this.user.uid === this.game.ownerId;
  }
  get player(): PlayerType | null {
    return this.game.players[this.user.uid] || null;
  }
  get players(): PlayersType {
    return this.game.players;
  }

  get state(): GameStateType | null {
    return this.game.state;
  }

  mounted() {
    window.location.hash = "/";
  }
}
